import React, { Component } from "react";
import store from "@/redux/store";
import {storeBaseSetting2, removeBaseSetting, editWebsite} from "@/reducers/Settings";
import { Link, useNavigate, useLocation } from "react-router-dom";

import { BuildingOfficeIcon, CreditCardIcon, UserIcon, UsersIcon } from '@heroicons/react/20/solid'

import { Edit as CustomerCompany } from "@/views/base/company/Edit";
import { useForm, SubmitHandler, useWatch } from "react-hook-form"
import  {ICustomer} from "@/models/Customer";
import {FieldHolder} from "@/components/holders/FieldHolder";
import { Switch,Label, Field } from '@headlessui/react'

export function Website({...props}) {
  const { register, handleSubmit, watch, reset,    formState, setValue, getValues } = useForm({
      defaultValues: props.data,
      values: props.data
    })
     const watchShowAge = watch("enabled"); 
   
    //setValue("type", props.data.type.toString() );

const tabs = [


  { name: 'Website gegevens', href: '#', icon: UserIcon, current: true },
]  // More people...

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

   const onSubmit: SubmitHandler = (data) => {
    event.preventDefault();
    event.stopPropagation();
    
    //console.debug( "SAVE DATA", data.getData() );
    store.dispatch( storeBaseSetting2( {data: data, type: "website"} ) );

    return false;

    }
    
    const editWebsiteEventHandler = async (event) => {
        event.preventDefault();
        event.stopPropagation();

        //console.debug( "SAVE DATA", data.getData() );
        store.dispatch( editWebsite( {data: props.data} ) ).then ((data) => {
            
            window.open(data.payload.data, '_blank');
        })
        
        
        return false;
    }
/*
  React.useEffect(() => {
      if(props.data && watch("key") != props.data.key) {
          reset(props.data);
      } else if(!props.data && formState.defaultValues && formState.defaultValues["key"] && formState.defaultValues["key"] != "") {
            for (const [key, value] of Object.entries(formState.defaultValues)) {
                formState.defaultValues[key] = "";
            }          
            reset(formState.defaultValues, { keepDirtyValues: true }); 
      }
  }, [formState, reset])
*/

  const onSaveWrapped = (data) => {
    event.preventDefault();
    event.stopPropagation();
    
    props.onSaveHandler(data);
      
    return false;
  };
  console.debug( "IS ENABLED", getValues('enabled') );
  return (
    <>
                        
    <div className="space-y-10 divide-y divide-gray-900/10 mt-8">
      <div className="grid grid-cols-1 gap-x-8 gap-y-8 md:grid-cols-1">
       <form className="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-2" onSubmit={handleSubmit(onSubmit)}>

          <div className="px-4 py-6 sm:p-8">
            <div className="mt-1 space-y-8 pb-12 sm:space-y-0   sm:pb-0">
    
                    
                           <Field className="flex items-center"> 
                    <Switch
                      defaultChecked={getValues('enabled')}      
                        onChange={(value) => {setValue('enabled', value)}}
                      className="group relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 data-[checked]:bg-indigo-600"
                    >
                      <span className="sr-only">Use setting</span>
                      <span
                        aria-hidden="true"
                        className="pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
                      />
                    </Switch>                
                    <Label as="span" className="ml-3 text-sm">
                        <span className="font-medium text-gray-900">Website instellingen</span>{' '}
                        <span className="text-gray-500"></span>
                      </Label>            
                         </Field>   
                
                         {getValues('enabled') == true && 
                            
                            <FieldHolder colspan="4" smcolspan="5" label={"Domein naam (URL)"} id="url" error={props?.state?.error} >
                            
                            <div>
                              <div className="mt-2 w-96">
                                <div className="flex items-center rounded-md bg-white px-3 outline-1 -outline-offset-1 outline-gray-300 focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-indigo-600">
                                <div className="shrink-0 text-base text-gray-500 select-none sm:text-sm/6">https://</div>
                                  <input
                                    id="url"
                                    type="text"
                                    {...register("url")}
                                    key={(props.data && props.data.url) ?? null}
                                    aria-describedby="price-currency"
                                    className="block min-w-0 grow bg-white py-1.5 pr-3 pl-1 text-base text-gray-900 placeholder:text-gray-400 focus:outline-none sm:text-sm/6"
                                  />

                                  <div id="price-currency" className="shrink-0 text-base text-gray-500 select-none sm:text-sm/6">
                                    web.paperchip.world
                                  </div>
                                </div>
                              </div>
                            </div>                            
                            
                            </FieldHolder>
                            
                            
                            
                            
                         }
                         
                         
                         {props?.data?.enabled == 1 && props?.data?.url != "" &&
                            <>
                            <a href="#"
                            onClick={(event) => editWebsiteEventHandler(event)}
                            className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                            >
                            Bewerken website
                            </a>
</>
                            
                         }

                </div>
          </div>
          <div className="flex items-center justify-end gap-x-6 border-t border-gray-900/10 px-4 py-4 sm:px-8">
            <Link to="/team" type="button" className="text-sm font-semibold leading-6 text-gray-900">
              Annuleren
            </Link>
            <button
              type="submit"
              className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Opslaan
            </button>
          </div>
        
        </form>
      </div>
      </div>

    


    </>
      );
}
